import type { IOption as IMandatoryOption } from 'click-controls/controls/form/field/field-select-checkbox';
import { CONFIG_UPDATE_DESCRIPTIONS } from './enums';

export const LIST_LOCATION_STATUS = [
  {
    id: 1,
    name: 'Active',
    value: 0
  },
  {
    id: 2,
    name: 'Inactive',
    value: 2
  }
];

export const LIST_USER_STATUS = [
  {
    id: 1,
    name: 'Active',
    value: true
  },
  {
    id: 2,
    name: 'Inactive',
    value: false
  }
];

export const LIST_LOCATION_FACILITIES = [
  {
    id: 1,
    name: 'Free Onsite Parking'
  },
  {
    id: 2,
    name: 'Onsite Parking'
  },
  {
    id: 3,
    name: 'Nearby Parking'
  },
  {
    id: 4,
    name: 'Disabled Parking'
  },
  {
    id: 5,
    name: 'Disabled Access'
  },
  {
    id: 6,
    name: 'Gym'
  },
  {
    id: 7,
    name: 'Hydro Pool'
  },
  {
    id: 8,
    name: 'Pool'
  },
  {
    id: 9,
    name: 'Gait Analysis'
  },
  {
    id: 10,
    name: 'Childcare Facilities'
  },
  {
    id: 11,
    name: 'Showers'
  },
  {
    id: 12,
    name: 'Diagnostic Scanning'
  },
  {
    id: 13,
    name: 'Studio'
  }
];

export const LOCATION_FACILITIES = [
  'Free Onsite Parking',
  'Onsite Parking',
  'Nearby Parking',
  'Disabled Parking',
  'Disabled Access',
  'Gym',
  'Hydro Pool',
  'Pool',
  'Gait Analysis',
  'Childcare Facilities',
  'Showers',
  'Diagnostic Scanning',
  'Studio'
];

export const CLIENT_MANDATORY_FIELD: IMandatoryOption[] = [
  {
    id: 0,
    label: 'Title',
    value: false,
    description: CONFIG_UPDATE_DESCRIPTIONS.Title
  },
  {
    id: 1,
    label: 'Date of Birth',
    value: false,
    description: CONFIG_UPDATE_DESCRIPTIONS.DateOfBirth
  },
  {
    id: 2,
    label: 'Mobile Number',
    value: false,
    description: CONFIG_UPDATE_DESCRIPTIONS.MobileNumber
  },
  {
    id: 3,
    label: 'Email Address',
    value: false,
    description: CONFIG_UPDATE_DESCRIPTIONS.Email
  }
];
